module.exports = __webpack_public_path__ + "static/media/1.6f36c7f9.png";